import { getBackgroundColor, getDisplayText, isDisabled } from './gridUtils';
import { Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../styles/CampaignGrid.css';

export function GridCell({block, selectFunc, hoverFunc, products, page, selected, activeGrids, currentUser}) {

    // Set variables
    const backgroundColor = getBackgroundColor(selected, block.id, products, page);
    const displayText = getDisplayText(products, page, block.id);
    const disabled = isDisabled(products, page, block.id);
    const textColor = disabled ? '#d9d9d9' : '#000000';

    // Variables for active users
    const gridId = `${page}page${block.id}`;
    const activeUsers = (activeGrids && activeGrids[gridId]) || [];
    const hasOtherUsers = activeUsers.some(user => user !== currentUser);

    const userTooltip = (
        <Tooltip>
            <div>
                <strong>Active Users:</strong>
                {activeUsers.map(user => (
                    <div key={user}>{user}</div>
                ))}
            </div>
        </Tooltip>
    );
    

    return (
        <Col xs={block.width} 
            className="col_square border border-dark"
            style={{
                backgroundColor: backgroundColor,
                aspectRatio: block.shape === 'standard' ? 1/1 : 2/1,
                position: 'relative'
            }}
        >
            {hasOtherUsers && (
                <OverlayTrigger overlay={userTooltip} placement="top">
                    <div className="user-indicator">👤</div>
                </OverlayTrigger>
            )}

            {!!products[`${page}page${block.id}`]?.product_finalized && (
                <div style={{
                    position: 'absolute',
                    top: '2px',
                    right: '2px',
                    backgroundColor: '#28a745',
                    color: 'white',
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '10px',
                    zIndex: 2
                }}>
                    ✓
                </div>
            )}
            <OverlayTrigger
                overlay={disabled ? <span></span> : (hoverFunc(block.id))}
                delay={{ show: 250, hide: 250 }}
            >
                <p className='grid_link'
                    onClick={() => selectFunc(block.id)}
                    style={{
                        lineHeight: "100%",
                        overflow: "hidden",
                        color: textColor
                    }}>
                    {displayText}
                </p>
            </OverlayTrigger>
        </Col>);
}